module.exports = __webpack_public_path__ + "img/600energie-dim.gif";